import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import NCZISetupInsuranceCompany, { NCZISetupInsuranceCompanyValues } from './NCZISetupInsuranceCompany';
import { TermItem } from '../../../../../graphql/graphql';
import { NcziSetupInsuranceSettings } from '../NcziSetupSettings';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: (values: NCZISetupInsuranceCompanyValues) => void;
	insuranceCompany: TermItem;
	currentSettings: NcziSetupInsuranceSettings | null
}

const NCZISetupInsuranceCompanyModal: React.FC<Props> = ({
	isOpen,
	onClose,
	onSubmit,
	insuranceCompany,
	currentSettings
}) => {
	return (
		<Modal opened={isOpen} onClose={onClose} fullScreen={false}>
			<Modal.Header title={insuranceCompany.name} />
			<Modal.Content>
				<NCZISetupInsuranceCompany
					onSubmit={onSubmit}
					insuranceCompany={insuranceCompany}
					currentSettings={currentSettings}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default NCZISetupInsuranceCompanyModal;
